import {useTranslation} from 'react-i18next';
import {Modal} from '../../../../../../components/modal/modal';
import {translations} from '../../../../../../i18n/translations';
import {Typography} from '@mui/material';

type DeleteOccurrenceModalProps = {
  name: string;
  entityId: string | undefined;
  submitting: boolean;
  onClose: () => void;
  onDelete: () => void;
};

export default function DeleteOccurrenceTypeModal({
  name,
  entityId,
  submitting,
  onClose,
  onDelete,
}: DeleteOccurrenceModalProps) {
  const {t} = useTranslation();
  return (
    <Modal
      open
      maxWidth="sm"
      fullWidth
      preventCloseClick
      onClose={onClose}
      className="occurrences-modal"
      actions={[
        {
          label: t(translations.modal.cancel),
          type: 'destructive',
          onClick: onClose,
          disabled: submitting,
        },
        {
          label: entityId ? t(translations.modal.delete) : t(translations.modal.revert),
          type: 'nondestructive',
          onClick: onDelete,
          disabled: submitting,
          loading: submitting,
        },
      ]}
    >
      {entityId && (
        <>
          <Typography className="title">
            {t(translations.office.professional_caregiver.settings.occurrences.delete_modal_title, {
              name: name,
            })}
          </Typography>
          <Typography className="subtitle">
            {t(
              translations.office.professional_caregiver.settings.occurrences.delete_modal_subtitle
            )}
          </Typography>
        </>
      )}
      {!entityId && (
        <>
          <Typography className="title">
            {t(translations.office.professional_caregiver.settings.occurrences.revert_modal_title, {
              name: name,
            })}
          </Typography>
          <Typography className="subtitle">
            {t(
              translations.office.professional_caregiver.settings.occurrences.revert_modal_subtitle
            )}
          </Typography>
        </>
      )}
    </Modal>
  );
}
